import { yTextToSlateElement } from '@slate-yjs/core'
import { logger } from '@tunasong/models'
import type { CoreElement } from '@tunasong/schemas'
import * as Y from 'yjs'
import { toSlateDoc } from '../legacy/convert.js'

export const getElementV1 = (yDoc: Y.Doc) => {
  const sharedTypeV1 = yDoc.getArray('doc')
  const value = toSlateDoc(sharedTypeV1)
  return value
}

export const getSharedTypeV1 = (yDoc: Y.Doc) => yDoc.getArray('doc')
export const getSharedTypeV2 = (yDoc: Y.Doc) => yDoc.get('content', Y.XmlText) as Y.XmlText

export const hasSharedTypeV1 = (yDoc: Y.Doc) => yDoc.share.has('doc')
export const hasSharedTypeV2 = (yDoc: Y.Doc) => yDoc.share.has('content')

const getElementV2 = (yDoc: Y.Doc) => yTextToSlateElement(getSharedTypeV2(yDoc)) as CoreElement

export const getElementValue = (yDoc: Y.Doc) => {
  const { v1, v2 } = getSlateYDocVersion(yDoc)
  if (v2) {
    return getElementV2(yDoc).children as CoreElement[]
  }
  if (v1) {
    return getElementV1(yDoc) as CoreElement[]
  }

  throw new Error(`Could not determine slate-yjs version`)
}

/** Version check for YDoc. We use this when migrating from v1 (slate-yjs, Y.Array) to v2 (@slate-yjs/core, Y.XMLText) */
export const getSlateYDocVersion = (yDoc: Y.Doc) => {
  const sharedTypeV1 = getSharedTypeV1(yDoc)
  const sharedTypeV2 = getSharedTypeV2(yDoc)
  const v1 = sharedTypeV1.length > 0
  let v2 = sharedTypeV2.length > 0

  // if both are zero-length, we assume it's a new Y.Doc
  if (!v1 && !v2) {
    logger.warn('Cannot determine version of Y.Doc - assuming v2')
    v2 = true // assume it's a new Y.Doc
  }

  return {
    v1,
    v2,
  }
}
